import { SelectionChangedEvent } from "ag-grid-community";
import { EdiItemCodeMappingEntity } from "domain/entity/EdiItemCodeMapping/EdiItemCodeMappingEntity";
import _ from "lodash";
import { INITIAL_EDI_ITEM_CODE_MAPPING_COL_DEF } from "presentation/constant/EdiItemCodeMapping/EdiItemCodeMappingMaintenanceColumnDefinition";
import { EdiItemCodeMappingMaintenanceConstant } from "presentation/constant/EdiItemCodeMapping/EdiItemCodeMappingMaintenanceConstant";
import { useEdiItemCodeMappingMaintenanceVM } from "presentation/hook/EdiItemCodeMapping/useEdiItemCodeMappingMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useEdiItemCodeMappingMaintenanceTracked } from "presentation/store/EdiItemCodeMapping/EdiItemCodeMappingMaintenanceProvider";
import RightClickMenuWithMoveAfter from "presentation/view/components/NbisRightClickMenu/RightClickMenuWithMoveAfter";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { createRef, memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Loader } from "veronica-ui-component/dist/component/core";


const EdiItemCodeMappingTablePanel: React.FC = () => {
    const [ediItemCodeMappingState] = useEdiItemCodeMappingMaintenanceTracked();
    const ediItemCodeMappingVM = useEdiItemCodeMappingMaintenanceVM();
    const gridRef: any = useRef(null);

    const messageBarVM = useMessageBarVM();

    // const [onTableSelectionClicked, setOnTableSelectionClicked] = useState<boolean>(false);
    const [anainfoState] = useANAInfoTracked();
    const { allowUpdate, allowCreate, operatingUnit } = anainfoState;
    const rightClickRef: any = createRef();
    // for right click menu with move after begin
    const [showMoveCursor, setShowMoveCursor] = useState<boolean>(false);
    const [allRows, setAllRows] = useState<EdiItemCodeMappingEntity[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [initialAllRows, setInitialAllRows] = useState<boolean>(true);

    const getAllRows = useCallback(() => {
        return allRows;
    }, [allRows]);

    const getSelectedRows = useCallback(() => {
        return ediItemCodeMappingState.selectedRows;
    }, [ediItemCodeMappingState.selectedRows]);

    // const getShowMoveCursor = useCallback(() => {
    //     return showMoveCursor;
    // }, [showMoveCursor]);
    // //for right click menu with move after end
    // useEffect(() => {
    //     //const columnDefs = (INITIAL_EDI_ITEM_CODE_MAPPING_COL_DEF?.slice());

    //     if (!ediItemCodeMappingState.selectedRows || ediItemCodeMappingState.selectedRows.length <= 0) {
    //         //gridRef.current?.gridRef.current.api?.setColumnDefs(columnDefs);
    //         if (!onTableSelectionClicked) {
    //             gridRef.current?.gridRef.current.api?.deselectAll();
    //         }
    //     }
    //     changeCursor("edi_item_code_mapping-table", getShowMoveCursor());
    // });

    // useEffect(() => {
    //     if (!onTableSelectionClicked) return;
    //     gridRef?.current?.gridRef.current.api?.deselectAll();
    //     changeCursor("edi_item_code_mapping-table", getShowMoveCursor());
    // }, [getShowMoveCursor, onTableSelectionClicked]);

    useEffect(() => {
        const handleRightClickMenu = (event: any) => {
            if (_.isEmpty(ediItemCodeMappingState.selectedRows) || !allowUpdate) {
                return;
            }
            event.preventDefault();
            rightClickRef.current.show(event);
        };
        document.getElementById('myDiv')?.addEventListener("contextmenu", handleRightClickMenu);

        return () => {
            document.getElementById('myDiv')?.removeEventListener("contextmenu", handleRightClickMenu);
        };
    }, [rightClickRef, allowUpdate, ediItemCodeMappingState.selectedRows]);

    // for right click menu with move after begin
    const onRefreshRow = useCallback((newAllRows: any[]) => {
        setAllRows(newAllRows);
        ediItemCodeMappingVM.updateSelectedRows([]);
        setShowMoveCursor(true);
    }, [ediItemCodeMappingVM]);

    const onMoveCancel = useCallback(() => {
        setInitialAllRows(true);
        setAllRows(ediItemCodeMappingState.tableData);
        ediItemCodeMappingVM.updateSelectedRows([]);
        setShowMoveCursor(false);
    }, [ediItemCodeMappingState.tableData, ediItemCodeMappingVM]);

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        // setOnTableSelectionClicked(true);
        ediItemCodeMappingVM.updateSelectedRows(selectedRows);
    }, [ediItemCodeMappingVM])

    const handleAddClick = useCallback(() => {
        ediItemCodeMappingVM.onAdd(operatingUnit);
    }, [ediItemCodeMappingVM, operatingUnit])

    const handleRowDoubleClick = useCallback((entity: EdiItemCodeMappingEntity) => {
        ediItemCodeMappingVM.onEdit(entity);
    }, [ediItemCodeMappingVM])

    const onSaveMove = useCallback(async (newAllRows: any[]) => {
        if (_.isEmpty(newAllRows)) return;

        setIsLoading(true);

        ediItemCodeMappingVM.onApply(newAllRows).then((res) => {
            if (!res || !res.success) {
                messageBarVM.showError('Move failed.');
                setInitialAllRows(true);
                setIsLoading(false);

                ediItemCodeMappingVM.updateSelectedRows([]);
                setShowMoveCursor(false);
            } else {
                ediItemCodeMappingVM.onSearch().then((data) => {
                    setInitialAllRows(true);
                    setIsLoading(false);

                    ediItemCodeMappingVM.updateSelectedRows([]);
                    setShowMoveCursor(false);
                }).catch((e) => {
                    setInitialAllRows(true);
                    setIsLoading(false);

                    ediItemCodeMappingVM.updateSelectedRows([]);
                    setShowMoveCursor(false);
                })
            }
        })
    }, [ediItemCodeMappingVM, messageBarVM]);

    const memoTable = useMemo(() => {
        return (
            <>
                {(allowUpdate) && <RightClickMenuWithMoveAfter disabled={_.isEmpty(getSelectedRows())}
                    rightClickRef={rightClickRef} selectedRows={getSelectedRows()} allRows={getAllRows()}
                    onSaveMove={onSaveMove} onCancel={onMoveCancel} onRefreshRow={onRefreshRow}
                    showConfirmMove={showMoveCursor} priorityName="priority" />}
                <div id="myDiv">
                    <NbisTable
                        id='edi_item_code_mapping-table'
                        headerLabel={EdiItemCodeMappingMaintenanceConstant.TITLE}
                        isNewColumnSetting={true}
                        columns={INITIAL_EDI_ITEM_CODE_MAPPING_COL_DEF}
                        data={allRows ?? []}
                        showPaginator={false}
                        editable={false}
                        showAddIcon={allowCreate}
                        onAddClick={handleAddClick}
                        showDeleteButton={false}
                        showReloadIcon={false}
                        isScrollHighlighted={true}
                        selectionMode={false}
                        isRowHighligted={true}
                        handleSelectionChanged={handleSelectionChange}
                        onRowDoubleClick={(e: any, entity: EdiItemCodeMappingEntity) => handleRowDoubleClick(entity)}
                        gridHeight="customHeight"
                        customHeight="calc(100vh - 75px)"
                        ref={gridRef}
                        rowSelection={showMoveCursor ? "single" : "multiple"}
                        // onBodyScroll={(e: any) => changeCursor("edi_item_code_mapping-table", getShowMoveCursor())}
                        showCutCursor={showMoveCursor}
                    />
                </div>
            </>
        );
    }, [allowCreate, allowUpdate, getSelectedRows, rightClickRef, getAllRows, onSaveMove, onMoveCancel, onRefreshRow, showMoveCursor, allRows, handleAddClick, handleSelectionChange, handleRowDoubleClick])

    useEffect(() => {
        if (initialAllRows && ediItemCodeMappingState.tableData && !_.isEmpty(ediItemCodeMappingState.tableData)) {
            setAllRows(ediItemCodeMappingState.tableData.map((ediItemCodeMappingEntity, index) => ({
                ...ediItemCodeMappingEntity,
                index: index || 0
            })));
            setInitialAllRows(false);
        }
    }, [allRows, initialAllRows, ediItemCodeMappingState.tableData]);

    return <><TableWrapper>
        {(isLoading) && <Loader Indicator="Spinner" size="Medium" />}
        {memoTable}
        {ediItemCodeMappingState.forceRefresh && <></>}
    </TableWrapper>
    </>;
}

export default memo(EdiItemCodeMappingTablePanel);
